import React, { FC, useEffect, useState } from 'react';
import { Image } from 'antd';
import placeholder from 'app/assets/images/redesign/placeholder.svg';
import { IGood } from 'entities/Goods/Goods.models';

interface IComponentProps {
  good: IGood | null;
}

export const GoodGallery: FC<IComponentProps> = ({ good }) => {
  const [activeImage, setActiveImage] = useState<string>(placeholder);

  useEffect(() => {
    if (good?.images?.[0]) {
      setActiveImage(good.images[0]);
    }
  }, [good]);

  const changeActiveImage = (image: string): void => {
    setActiveImage(image);
  };

  return (
    <div className="good-gallery">
      <div className="relative">
        <div className="flex direction-column good-gallery-swiper">
          {good?.images?.map((item, index) => {
            const active = item === activeImage;

            return (
              <div
                key={index}
                className={`mb-5 cursor-pointer good-gallery-swiper-slide ${active ? 'good-gallery-swiper-slide-active' : ''}`}
                onClick={() => changeActiveImage(item)}
              >
                <Image wrapperClassName="good-gallery-swiper-slide-image" preview={false} src={item} />
              </div>
            );
          })}
        </div>
      </div>

      <div className="good-gallery-main">
        <Image wrapperClassName="good-gallery-main-image" preview={false} src={activeImage} />
      </div>
    </div>
  );
};
